var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoadingStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.999 22C14.4077 22 12.8816 21.3679 11.7564 20.2426C10.6312 19.1174 9.99902 17.5913 9.99902 16C9.99902 15.7348 9.89367 15.4804 9.70613 15.2929C9.51859 15.1054 9.26424 15 8.99902 15C8.73381 15 8.47945 15.1054 8.29192 15.2929C8.10438 15.4804 7.99902 15.7348 7.99902 16C7.99902 17.5913 7.36688 19.1174 6.24166 20.2426C5.11645 21.3679 3.59032 22 1.99902 22C1.73381 22 1.47945 22.1054 1.29192 22.2929C1.10438 22.4804 0.999023 22.7348 0.999023 23C0.999023 23.2652 1.10438 23.5196 1.29192 23.7071C1.47945 23.8946 1.73381 24 1.99902 24C3.59032 24 5.11645 24.6321 6.24166 25.7574C7.36688 26.8826 7.99902 28.4087 7.99902 30C7.99902 30.2652 8.10438 30.5196 8.29192 30.7071C8.47945 30.8946 8.73381 31 8.99902 31C9.26424 31 9.51859 30.8946 9.70613 30.7071C9.89367 30.5196 9.99902 30.2652 9.99902 30C9.99902 28.4087 10.6312 26.8826 11.7564 25.7574C12.8816 24.6321 14.4077 24 15.999 24C16.2642 24 16.5186 23.8946 16.7061 23.7071C16.8937 23.5196 16.999 23.2652 16.999 23C16.999 22.7348 16.8937 22.4804 16.7061 22.2929C16.5186 22.1054 16.2642 22 15.999 22Z",
    fill: "url(#paint0_linear_3219_31840)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.999 12.5C28.8064 12.4974 27.6633 12.0224 26.82 11.1791C25.9766 10.3357 25.5017 9.19266 25.499 8C25.499 7.73478 25.3937 7.48043 25.2061 7.29289C25.0186 7.10536 24.7642 7 24.499 7C24.2338 7 23.9795 7.10536 23.7919 7.29289C23.6044 7.48043 23.499 7.73478 23.499 8C23.4964 9.19266 23.0214 10.3357 22.1781 11.1791C21.3347 12.0224 20.1917 12.4974 18.999 12.5C18.7338 12.5 18.4795 12.6054 18.2919 12.7929C18.1044 12.9804 17.999 13.2348 17.999 13.5C17.999 13.7652 18.1044 14.0196 18.2919 14.2071C18.4795 14.3946 18.7338 14.5 18.999 14.5C20.1917 14.5026 21.3347 14.9776 22.1781 15.8209C23.0214 16.6643 23.4964 17.8073 23.499 19C23.499 19.2652 23.6044 19.5196 23.7919 19.7071C23.9795 19.8946 24.2338 20 24.499 20C24.7642 20 25.0186 19.8946 25.2061 19.7071C25.3937 19.5196 25.499 19.2652 25.499 19C25.5017 17.8073 25.9766 16.6643 26.82 15.8209C27.6633 14.9776 28.8064 14.5026 29.999 14.5C30.2642 14.5 30.5186 14.3946 30.7061 14.2071C30.8937 14.0196 30.999 13.7652 30.999 13.5C30.999 13.2348 30.8937 12.9804 30.7061 12.7929C30.5186 12.6054 30.2642 12.5 29.999 12.5Z",
    fill: "url(#paint1_linear_3219_31840)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99902 6C10.7947 6 11.5577 6.31607 12.1203 6.87868C12.683 7.44129 12.999 8.20435 12.999 9C12.999 9.26522 13.1044 9.51957 13.2919 9.70711C13.4795 9.89464 13.7338 10 13.999 10C14.2642 10 14.5186 9.89464 14.7061 9.70711C14.8937 9.51957 14.999 9.26522 14.999 9C14.999 8.20435 15.3151 7.44129 15.8777 6.87868C16.4403 6.31607 17.2034 6 17.999 6C18.2642 6 18.5186 5.89464 18.7061 5.70711C18.8937 5.51957 18.999 5.26522 18.999 5C18.999 4.73478 18.8937 4.48043 18.7061 4.29289C18.5186 4.10536 18.2642 4 17.999 4C17.2034 4 16.4403 3.68393 15.8777 3.12132C15.3151 2.55871 14.999 1.79565 14.999 1C14.999 0.734784 14.8937 0.48043 14.7061 0.292893C14.5186 0.105357 14.2642 0 13.999 0C13.7338 0 13.4795 0.105357 13.2919 0.292893C13.1044 0.48043 12.999 0.734784 12.999 1C12.999 1.79565 12.683 2.55871 12.1203 3.12132C11.5577 3.68393 10.7947 4 9.99902 4C9.73381 4 9.47945 4.10536 9.29192 4.29289C9.10438 4.48043 8.99902 4.73478 8.99902 5C8.99902 5.26522 9.10438 5.51957 9.29192 5.70711C9.47945 5.89464 9.73381 6 9.99902 6Z",
    fill: "url(#paint2_linear_3219_31840)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.999 31C20.5513 31 20.999 30.5523 20.999 30C20.999 29.4477 20.5513 29 19.999 29C19.4467 29 18.999 29.4477 18.999 30C18.999 30.5523 19.4467 31 19.999 31Z",
    fill: "url(#paint3_linear_3219_31840)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.999 18C15.5513 18 15.999 17.5523 15.999 17C15.999 16.4477 15.5513 16 14.999 16C14.4467 16 13.999 16.4477 13.999 17C13.999 17.5523 14.4467 18 14.999 18Z",
    fill: "url(#paint4_linear_3219_31840)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99902 13C3.55131 13 3.99902 12.5523 3.99902 12C3.99902 11.4477 3.55131 11 2.99902 11C2.44674 11 1.99902 11.4477 1.99902 12C1.99902 12.5523 2.44674 13 2.99902 13Z",
    fill: "url(#paint5_linear_3219_31840)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.999 6C27.5513 6 27.999 5.55228 27.999 5C27.999 4.44772 27.5513 4 26.999 4C26.4467 4 25.999 4.44772 25.999 5C25.999 5.55228 26.4467 6 26.999 6Z",
    fill: "url(#paint6_linear_3219_31840)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.219 25.7005C28.7713 25.7005 29.219 25.2528 29.219 24.7005C29.219 24.1482 28.7713 23.7005 28.219 23.7005C27.6667 23.7005 27.219 24.1482 27.219 24.7005C27.219 25.2528 27.6667 25.7005 28.219 25.7005Z",
    fill: "url(#paint7_linear_3219_31840)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3219_31840",
    x1: 15.999,
    y1: 0,
    x2: 15.999,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7144FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B74AF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3219_31840",
    x1: 15.999,
    y1: 0,
    x2: 15.999,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7144FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B74AF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3219_31840",
    x1: 15.999,
    y1: 0,
    x2: 15.999,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7144FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B74AF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3219_31840",
    x1: 15.999,
    y1: 0,
    x2: 15.999,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7144FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B74AF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3219_31840",
    x1: 15.999,
    y1: 0,
    x2: 15.999,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7144FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B74AF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3219_31840",
    x1: 15.999,
    y1: 0,
    x2: 15.999,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7144FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B74AF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3219_31840",
    x1: 15.999,
    y1: 0,
    x2: 15.999,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7144FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B74AF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3219_31840",
    x1: 15.999,
    y1: 0,
    x2: 15.999,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7144FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B74AF3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingStars);
export default __webpack_public_path__ + "static/media/loading_stars.045025bffd1c62a2153647719014b6a0.svg";
export { ForwardRef as ReactComponent };